import React from "react";

interface InfoCardProps {
  title: string;
  children: React.ReactNode;
  action?: React.ReactNode;
}

export default function InfoCard({ title, children, action }: InfoCardProps) {
  return (
    <div className="bg-white rounded-lg shadow-md overflow-hidden hover:shadow-lg transition-shadow duration-150">
      <div className="bg-purple-950 px-4 py-3 flex justify-between items-center">
        <h3 className="text-lg font-semibold text-purple-100">{title}</h3>
        {action && <div>{action}</div>}
      </div>
      <div className="p-4">{children}</div>
    </div>
  );
}

interface InfoItemProps {
  label: string;
  value: string | number | boolean | null | undefined;
  formatter?: (value: any) => string;
}

export function InfoItem({ label, value, formatter }: InfoItemProps) {
  let displayValue: string;

  if (formatter) {
    displayValue = formatter(value);
  } else if (value === null || value === undefined) {
    displayValue = "-";
  } else if (typeof value === "boolean") {
    displayValue = value ? "Yes" : "No";
  } else {
    displayValue = String(value);
  }

  return (
    <div>
      <dt className="text-xs font-medium text-gray-500 uppercase tracking-wider mb-1">
        {label}
      </dt>
      <dd className="text-sm font-medium text-gray-900">{displayValue}</dd>
    </div>
  );
}
